import React, { FC } from "react"
import Player from "./player/Player"
import { Provider } from "react-redux"
import store from "./store"
//import AudioElementPlayer from "./audioElementPlayer/audioElementPlayer"
interface IProps {}

const App: FC<IProps> = () => {
  return (
    <Provider store={store}>
      <Player />
    </Provider>
  )
}

export default App
